import userprofileRefreshReducer  from './userProfileRefreshSlice';
import profileReducer from './profileSlice';

const userReducers = {
    userprofileRefreshReducer: userprofileRefreshReducer,
    profile: profileReducer,

};

export default userReducers;